export * from './schedule.component';
export * from './match-tile/match-tile.component';
